import { requiresSubDamageLevel } from 'utils/damage'
import * as Yup from 'yup'

export const notifyEventPatientSchema = Yup.object().shape({
    date_incident: Yup.date().required('Data do incidente é obrigatória'),
    incident_title: Yup.string().required('Título do incidente é obrigatório'),
    incident_description: Yup.string().required(
        'Descrição do incidente é obrigatória'
    ),
    // Campos comentados temporariamente - removidos do formulário do paciente
    // incident_type: Yup.string().required('Tipo do incidente é obrigatório'),
    // damage_level: Yup.string().required('Classificação do Incidente é obrigatório'),
    incident_type: Yup.string().notRequired(),
    damage_level: Yup.string().notRequired(),
    location_incident: Yup.string().required(
        'Hospital onde o evento ocorreu é obrigatório'
    ),
    incident_sector: Yup.string().required('Setor notificado é obrigatório'),
    shift_incident: Yup.string().required(
        'Turno que o evento ocorreu é obrigatório'
    ),
    notification_type_toggle: Yup.boolean(),
    notification_type: Yup.string().notRequired(),
    reporter_name: Yup.string().when('notification_type_toggle', {
        is: true,
        then: (schema) => schema.required('Nome completo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
    }),
    u_attachments_url: Yup.string(),
    u_attachments_string: Yup.string(),
    u_attachments_size: Yup.string(),
    u_version: Yup.string(),
    u_sub_damage_level: Yup.string().when('damage_level', {
        is: (damageLevel) => requiresSubDamageLevel(damageLevel),
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired()
    })
})

export type NotifyEventPatientType = Yup.InferType<typeof notifyEventPatientSchema>

